<template>
    <div>
       <el-radio-group v-model="direction">
            <el-radio label="ltr">从左往右开</el-radio>
            <el-radio label="rtl">从右往左开</el-radio>
            <el-radio label="ttb">从上往下开</el-radio>
            <el-radio label="btt">从下往上开</el-radio>
        </el-radio-group>

    <el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
    点我打开
    </el-button>

    <el-drawer
    title="我是标题"
    :visible.sync="drawer"
    :direction="direction"
    :before-close="handleClose">
        <span>我来啦!</span>
    </el-drawer>
    </div>
</template>
<script>
import { UploadImage} from "../../until/ZeusApiSDK/Logic/UploadLogic";
export default {
    data() {
        return {
            drawer: false,
            direction: 'rtl',
        }
    },
    methods: {
        handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
        //图片上传成功之后返回数据
        // handleAvatarSuccess:function(res, file){
        // },
        // handleerror:function(err, file, fileList){
        // }
        // uploadExcel接口,我这里使用了两种方式传参，最后记得加上请求头
        
    }
}
</script>
<style lang="less" scoped>
//图片上传样式开始 .avatar-uploader
.el-upload {
    border: 1px dashed #d9d9d9 ;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
//图片上传样式结束
</style>